import { shadeColor } from '@app/utils/utils';

import { BASE_COLORS } from '../constants';
import { ITheme } from '../types';

const CNH_COLORS = {
  red: '#C3231E',
  black: '#000000',
  darkGray: '#9B9B9B',
  lightGray: '#C8C8C8',
} as const;

export const cnhColorsTheme: ITheme = {
  primary: CNH_COLORS.red,
  primaryText: CNH_COLORS.red,
  primary1: CNH_COLORS.black,
  privarySelect: '#F4D3D2',
  primaryGradient: `linear-gradient(211.49deg, ${CNH_COLORS.red} 15.89%, ${CNH_COLORS.black} 121.11%)`,
  light: CNH_COLORS.lightGray,
  secondary: CNH_COLORS.darkGray,
  error: CNH_COLORS.red,
  warning: '#FFB155',
  success: '#30AF5B',
  background: BASE_COLORS.white,
  secondaryBackground: '#F4F4F4',
  secondaryBackgroundSelected: shadeColor('#F4F4F4', -5),
  additionalBackground: BASE_COLORS.white,
  collapseBackground: CNH_COLORS.black,
  timelineBackground: '#F4F4F4',
  siderBackground: CNH_COLORS.black,
  spinnerBase: CNH_COLORS.red,
  scroll: CNH_COLORS.lightGray,
  border: CNH_COLORS.lightGray,
  borderNft: CNH_COLORS.darkGray,
  textMain: CNH_COLORS.black,
  textLight: '#666666',
  textSuperLight: CNH_COLORS.darkGray,
  textSecondary: BASE_COLORS.white,
  textDark: CNH_COLORS.black,
  textNftLight: CNH_COLORS.darkGray,
  textSiderPrimary: BASE_COLORS.white,
  textSiderSecondary: BASE_COLORS.white,
  subText: 'rgba(0, 0, 0, 0.55)',
  shadow: 'rgba(0, 0, 0, 0.1)',
  boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.1)',
  boxShadowHover: '0 4px 16px 0 rgba(0, 0, 0, 0.22)',
  boxShadowNft:
    '0px 16px 24px rgba(0, 0, 0, 0.08), 0px 2px 6px rgba(0, 0, 0, 0.06)',
  boxShadowNftSecondary: '0px 10px 20px rgba(0, 0, 0, 0.06)',
  dashboardMapBackground: '#F2F2F2',
  dashboardMapCircleColor: CNH_COLORS.lightGray,
  dashboardMapControlDisabledBackground: CNH_COLORS.lightGray,
  notificationSuccess: '#EFFFF4',
  notificationPrimary: '#F9E5E4',
  notificationWarning: '#FFF4E7',
  notificationError: '#F9E5E4',
  heading: CNH_COLORS.black,
  borderBase: CNH_COLORS.lightGray,
  disable: 'rgba(0, 0, 0, 0.45)',
  disabledBg: 'rgba(200, 200, 200, 0.2)',
  layoutBodyBg: '#EFEFEF',
  layoutHeaderBg: 'transparent',
  layoutSiderBg: `linear-gradient(180deg, ${CNH_COLORS.black} 0%, #242424 68%, ${CNH_COLORS.red} 145%)`,
  inputPlaceholder: '#666666',
  itemHoverBg: '#F4F4F4',
  backgroundColorBase: '#F4F4F4',
  avatarBg: CNH_COLORS.lightGray,
  alertTextColor: BASE_COLORS.white,
  breadcrumb: 'rgba(0, 0, 0, 0.55)',
  icon: CNH_COLORS.darkGray,
  iconHover: CNH_COLORS.red,
  tableHeaderBackground: CNH_COLORS.lightGray,
  tableBorderColor: CNH_COLORS.lightGray,
  tableHoverColor: '#FCE9E8',
};
